<template>
  <div class="option-list__item-wrapper" :style="{marginBottom: this.descriptionRowHeight + 'px'}">
    <button
      class="option-list__item"
      :class="currentOption.Selected ? 'is--selected' : ''"
      v-on:click="onClick"
    >
      <div class="option-list__item__badge" v-if="option.BadgeIcon">
        <img :src="option.BadgeIcon" alt="">
      </div>
      <img :src="option.ImageUrl" class="option-list__item__image" alt="">
      <div class="option-list__item__content">
        <h3 class="option-list__item__title">{{ option.Header}}</h3>
      </div>
    </button>
    <div class="option-list__item__description" v-if="false">
      <transition
        name="slide-down"
        v-on:enter="startTransition"
        v-on:after-enter="endTransition"
        v-on:before-leave="startTransition"
        v-on:after-leave="endTransition">
      >
        <div
          class="option-list__item__description__inner"
          style="overflow: hidden;"
          v-if="!!option.Description && currentOption.Selected"
        >
          <div v-html="option.Description">
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>

import Vue from 'vue';
import Component from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import { mapGetters, mapState, mapMutations } from 'vuex';

//
@Component({
  data() {
    return {
      optionStyleObject: {
        gridTemplateRows: '1fr ' + this.descriptionRowHeight + 'px'
      }
    }
  },
  props: {
  },
  computed: {
    ...mapGetters('buyGuide', {
      getOptionByIndex: 'getOptionByIndex',
      getCurrentStep: 'getCurrentStep'
    }),
    ...mapState({
      currentStepIndex: state => state.buyGuide.currentStepIndex,
      steps: state => state.buyGuide.steps,
    }),
    currentOption () {
      return this.getOptionByIndex(this.stepIndex, this.optionIndex)
    },
    currentStep () {
      return this.getCurrentStep(this.currentStepIndex)
    }
  },
  components: {
  },
  methods: {
    ...mapMutations(['buyGuide/setSelectedOption'])
  }
})
export default class Option extends Vue {
  @Prop() option;
  @Prop() optionIndex;
  @Prop() stepIndex;
  descriptionRowHeight = 0;


  created() {
    // console.log('Option created');
    this.showDescription = this.currentOption.Selected;
  }

  onClick() {
    this.setSelectedOption(this.option);
  }

  setSelectedOption(option) {
    this.$store.commit(
      'buyGuide/setSelectedOption', {
        option
      }
    )
  }

  startTransition(el) {
    el.style.height = el.scrollHeight + 'px'
  }

  endTransition(el) {
    this.descriptionRowHeight = el.scrollHeight;
    el.style.height = ''
  }

}
</script>

<style>

</style>

